export default __webpack_public_path__ + "images/PV.7b2c4cf.png";